"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Favorites = function Favorites() {
  return _react2.default.createElement(
    "div",
    { className: "quiver-intro-modal__item__icon" },
    _react2.default.createElement(
      "svg",
      {
        width: "36px",
        height: "33px",
        viewBox: "0 0 36 33",
        className: "quiver-intro-modal__favorites--icon"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("polygon", {
          id: "path-1-2-3",
          points: "18 27.7549505 11.8117647 31 13.0117647 24.1336634 8 19.2660891 \n            14.9176471 18.2549505 18 12 21.0823529 18.2549505 28 19.2660891 22.9882353 \n            24.1336634 24.1882353 31"
        })
      ),
      _react2.default.createElement(
        "g",
        {
          id: "onboarding-modal",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          transform: "translate(-56.000000, -312.000000)"
        },
        _react2.default.createElement(
          "g",
          { id: "Group-8" },
          _react2.default.createElement(
            "g",
            {
              id: "Group-9",
              transform: "translate(56.000000, 312.000000)"
            },
            _react2.default.createElement("rect", {
              id: "Rectangle-11-Copy",
              fillOpacity: "0.300000012",
              fill: "#96A9B2",
              x: "0",
              y: "0",
              width: "36",
              height: "24"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-8",
              fill: "#42A5FC",
              x: "0",
              y: "3",
              width: "36",
              height: "5"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-15",
              fill: "#FFFFFF",
              x: "4",
              y: "5",
              width: "4",
              height: "1"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-10",
              fill: "#FFFFFF",
              x: "10",
              y: "5",
              width: "4",
              height: "1"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-11",
              fill: "#FFFFFF",
              x: "16",
              y: "5",
              width: "4",
              height: "1"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-12",
              fill: "#FFFFFF",
              x: "22",
              y: "5",
              width: "4",
              height: "1"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-3-Copy-13",
              fill: "#FFFFFF",
              x: "28",
              y: "5",
              width: "4",
              height: "1"
            }),
            _react2.default.createElement(
              "g",
              {
                id: "Shape",
                fillRule: "nonzero"
              },
              _react2.default.createElement("use", {
                fill: "#FFFFFF",
                fillRule: "evenodd",
                xlinkHref: "#path-1-2-3"
              }),
              _react2.default.createElement("path", {
                stroke: "#FFFFFF",
                strokeWidth: "1",
                d: "M18,28.3195267 L11.1443526,31.9145605 L12.4737025,24.3080905 \n                  L6.92399789,18.9180531 L14.5853067,17.798215 L18,10.8688536 \n                  L21.4146933,17.798215 L29.0760021,18.9180531 L23.5262975,24.3080905 \n                  L24.8556474,31.9145605 L18,28.3195267 Z"
              })
            ),
            _react2.default.createElement("polygon", {
              id: "Shape",
              fill: "#42A5FC",
              fillRule: "nonzero",
              points: "18 27.7549505 11.8117647 31 13.0117647 24.1336634 8 19.2660891 \n                14.9176471 18.2549505 18 12 21.0823529 18.2549505 28 19.2660891 22.9882353 \n                24.1336634 24.1882353 31"
            })
          )
        )
      )
    )
  );
};

exports.default = Favorites;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/IntroModal/FavoritesIcon.js
// module id = 595
// module chunks = 11